function Skeleton({className, ...props}) {
  return (
    <div
      data-slot={"skeleton"}
      className={`bg-[#ddd]/30 animate-pulse rounded-md ${className}`}
      {...props}
    />
  );
}

export default Skeleton;
